export const colorPrismicMap = {
  terracotta: 'primary',
  herb: 'primary-dark',
  stone: 'primary-light',
};
